export default __webpack_public_path__ + "assets/png/1b07eeb9842e36098a9cacf93c806c81.png";